// extracted by mini-css-extract-plugin
export default {"details":"details_2Ziz","isBrowser":"isBrowser_2j9b","collapsibleContent":"collapsibleContent_3OHp"};